import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REACT_APP_API_URL } from '../../app/app.config';
import { IFilterLocations, ILocationResponse, ILocationsResponse } from './types';

const ACCESS_TOKEN_NAME = 'token';

export const locationsApi = createApi({
    reducerPath: 'locationsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: REACT_APP_API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem(ACCESS_TOKEN_NAME);
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            headers.set('Accept', 'application/json');
            headers.set('Accept-Language', 'en');
            headers.set('Content-Type', 'application/json');
            return headers;
        },
    }),
    endpoints: builder => ({
        getLocationById: builder.query<ILocationResponse, string>({
            query: id => `/commercial/locations/${id}`,
        }),
        getLocations: builder.query<ILocationsResponse, IFilterLocations>({
            query: filter => ({
                url: '/commercial/locations',
                params: filter,
            }),
        }),
    }),
});

export const { useGetLocationByIdQuery, useGetLocationsQuery } = locationsApi;
